import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(
    private snackBar: MatSnackBar,
  ) { }

  public sendErrorToUser(message?: string) {
    this.snackBar.open(message || $localize`something went wrong. Please reload the Page and try again.`, '', {
      duration: 10000,
      panelClass: ['error']
    });
  }

  public sendSuccessToUser(text?: string) {
    this.snackBar.open(text || $localize`saved`, '', {
      duration: 3000,
      panelClass: ['success']
    });
  }
}
